import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import baseStyles from './styles/baseStyles';
import FontWeight from '../tokens/fontWeights';
const getStyles = createUseStyles({
    ...baseStyles,
    big: {
        fontSize: '1.6rem'
    },
    small: {
        fontSize: '1.4rem'
    },
    xsmall: {
        fontSize: '1.2rem'
    },
    title1: {},
    title2: {
        fontSize: '3.6rem'
    },
    title3: {},
    title4: {
        fontSize: '2.4rem',
    },
    title5: {
        fontSize: '2rem'
    },
    title6: {},
    thin: {
        fontWeight: FontWeight.Thin
    },
    light: {
        fontWeight: FontWeight.Light
    },
    regular: {
        fontWeight: FontWeight.Regular
    },
    medium: {
        fontWeight: FontWeight.Medium
    },
    bold: {
        fontWeight: FontWeight.Bold
    },
    heavy: {
        fontWeight: FontWeight.Heavy
    }
});
const P = ({ children, className, type = 'small', weight }) => {
    const styles = getStyles();
    return React.createElement("p", { className: classNames(styles[type], { [styles[weight]]: weight }, className) }, children);
};
export default P;
//# sourceMappingURL=P.js.map